module.exports = __webpack_public_path__ + "static/media/PlaceholderCardImage.13a8115b.svg";